
    import React from 'react';
    import { useAppVersionCreate, useAppVersionSoftDelete,useAppVersionMultipleSoftDelete, useAppVersionUpdate } from '../../queries/AppVersion.queries';
    import AppVersion from './AppVersion';
    
    const AppVersionContainer = () => {
    
      const {mutate:addRecord} = useAppVersionCreate();
      const {mutate:editRecord} = useAppVersionUpdate();
      const {mutate:deleteRecord} = useAppVersionSoftDelete();
      const {mutate:deleteRecords} = useAppVersionMultipleSoftDelete();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <AppVersion 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
        />
      )
    }
    
    export default AppVersionContainer;
    